export const formatDate = (dateStr: string) => {
  return new Date(dateStr).toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
      day: "2-digit",
      timeZone: "UTC"
  });
};